var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({
      height: 'calc(100vh - 135px)',
      'border-radius': '5px',
    }),attrs:{"id":`${_vm.nameMap}_${_vm.initialDate}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }